/**
 * A pale pad behind a third-party mark, in dark mode only.
 *
 * Carrier, bank and card logos arrive as PNGs drawn for a light page, and they
 * fail on a dark one in two opposite ways. Some are dark ink on transparency
 * (`aaacooper` is 53% transparent with ink at luminance 32) and vanish; others
 * are opaque white rectangles (`estes`, `saia`) and glare as bare white blocks.
 * The pale pad gives the dark ink its light backdrop. The white rectangles
 * still show as white blocks on it unless blended — `LogoBackdrop` multiplies
 * its child into the pad for that; `<Image logo>` does not.
 *
 * The pad is `--color-logo-backdrop`, a soft grey, not white. Plenty of the
 * artwork has transparent margins, so a white pad showed as a bright white
 * frame around the mark and shouted louder than the logo.
 *
 * There is no recolouring our way out of this: the artwork is a third party's
 * and arrives as flat pixels.
 *
 * The fill sits flush behind the mark, with no inset. A card or bank brand
 * fills its own box, so an inset shows as a band around the logo and reads as a
 * thick border.
 *
 * Carrier artwork is the other case: it varies wildly in trim and looks cramped
 * flush, which is why `LogoBackdrop` adds `dark:p-1.5` on top of this. Note
 * `<Image logo>` also carries Hubble's carrier marks (via `CarrierLogoImage`),
 * so those are flush today while the dashboard's are inset — a known gap, not a
 * statement about the artwork.
 *
 * Every class is `dark:`-scoped, so light mode renders the mark untouched.
 * Deliberate exception elsewhere: a QR code's quiet zone must stay literally
 * white in both themes, or camera detection fails — that is not this.
 */
export const logoBackdropClasses =
  "dark:rounded dark:border dark:border-logo-backdrop-border dark:bg-logo-backdrop";
